import { Link } from "react-router-dom";

interface LogoProps {
  size?: "small" | "medium" | "large";
  showText?: boolean;
  className?: string;
  variant?: "default" | "light";
  to?: string;
  onPointerDown?: () => void;
}

export default function Logo({
  size = "medium",
  showText = true,
  className = "",
  variant = "default",
  to = "/",
  onPointerDown,
}: LogoProps) {
  const getSizeClasses = () => {
    switch (size) {
      case "small":
        return { logo: "h-6 w-auto", text: "text-lg" };
      case "medium":
        return { logo: "h-8 w-auto", text: "text-xl" };
      case "large":
        return {
          logo: "h-8 w-auto",
          text: "text-lg",
        };
      default:
        return { logo: "h-8 w-auto", text: "text-lg" };
    }
  };

  const sizeClasses = getSizeClasses();

  const logoContent = (
    <>
      <img
        src="/logo_white.svg"
        alt="DealHawk Logo"
        className={`${sizeClasses.logo} object-contain`}
      />
      {showText && (
        <span
          translate="no"
          className={`${sizeClasses.text} font-bold ${
            variant === "light" ? "text-white" : "text-primary-900"
          }`}
        >
          DealHawk
        </span>
      )}
    </>
  );

  return (
    <Link
      to={to}
      onPointerDown={onPointerDown}
      className={`flex items-center gap-1 sm:gap-1  hover:opacity-80 transition-opacity duration-200 ${className}`}
    >
      {logoContent}
    </Link>
  );
}
